import React, { useState } from "react";
import { MANUAL_FIELDS } from "../../import/extraction-to-preview";

// Last resort: the headers were so unusual that no passenger name was recognized.
// The operator points at the columns and we rebuild the list from that.
const ColumnMapper = ({ headers = [], initialMapping = {}, onApply }) => {
  const [mapping, setMapping] = useState(() => ({ ...initialMapping }));
  const nameReady = mapping.name != null || (mapping.firstName != null && mapping.lastName != null);

  return (
    <section className="start-ask start-ask--mapper">
      <h3>We couldn’t tell which column holds the passenger names</h3>
      <p className="start-muted">Point us to the right columns and the list below refreshes. Only the name is required.</p>
      <div className="start-mapping">
        {MANUAL_FIELDS.map((field) => (
          <label key={field.id}>
            <span>{field.label}</span>
            <select
              value={mapping[field.id] ?? ""}
              onChange={(event) =>
                setMapping((current) => ({
                  ...current,
                  [field.id]: event.target.value === "" ? null : Number(event.target.value),
                }))
              }
            >
              <option value="">Not in this file</option>
              {headers.map((header, index) => (
                <option key={`${header}-${index}`} value={index}>
                  {header}
                </option>
              ))}
            </select>
          </label>
        ))}
      </div>
      <button type="button" className="start-btn" disabled={!nameReady} onClick={() => onApply(mapping)}>
        Use these columns
      </button>
    </section>
  );
};

export default ColumnMapper;
